import { render, staticRenderFns } from "./questionPreview.vue?vue&type=template&id=776db4be&scoped=true"
import script from "./questionPreview.vue?vue&type=script&lang=js"
export * from "./questionPreview.vue?vue&type=script&lang=js"
import style0 from "./questionPreview.vue?vue&type=style&index=0&id=776db4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776db4be",
  null
  
)

export default component.exports